import { useState, type CSSProperties } from 'react'
import { Collapse, type CollapseProps } from 'antd'
import { useSnapshot } from 'valtio'
import { groupBy } from 'lodash'
import { CircleChevronRight } from 'lucide-react'
import styles from './selection.module.less'
import PromptModal from '@/components/PromptEditor/modal'
import { configState } from '@/store'
import { CaretRightOutlined } from '@ant-design/icons'

const Icon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="-0.5"
      y="0.5"
      width="19"
      height="19"
      rx="9.5"
      transform="matrix(-1 0 0 1 19 0)"
      stroke="white"
      strokeOpacity="0.4"
    />
    <path
      d="M8 13.5L12 10L8 6.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default () => {
  const { feature } = useSnapshot(configState) as any

  const [editItem, setEditItem] = useState({})
  const [openModal, setOpenModal] = useState(false)

  const getItems: () => CollapseProps['items'] = () => {
    return groupData.map(item => {
      return {
        key: item.tag,
        label: item.tag,
        style: {
          border: 'none',
        },
        children: (
          <div className={styles.logoContainer}>
            {item.data.map(logoItem => (
              <div
                key={logoItem.logo_url}
                className={`${styles.logoItem}`}
                onClick={() => {
                  handleClick(logoItem)
                }}
              >
                <img className="object-contain" src={logoItem.logo_url} />
                <div className={styles.title}>
                  <span>{logoItem.title}</span>
                  {Icon}
                  {/* <CircleChevronRight size={20} strokeWidth={1.5} /> */}
                </div>
              </div>
            ))}
          </div>
        ),
      }
    })
  }
  const groupData = Object.entries(groupBy(feature, 'tag')).map(
    ([k, data]) => ({
      tag: k,
      data,
    }),
  )

  const handleClick = (item: any) => {
    setEditItem(item)
    setOpenModal(true)
  }

  return (
    <div className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto scrollbar-none pb-5">
      <Collapse
        ghost
        className={styles.collapseWrap}
        accordion={true}
        items={getItems()}
        defaultActiveKey={['AI绘画']}
        expandIconPosition="end"
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      />
      <PromptModal
        open={openModal}
        onCancel={() => {
          setOpenModal(false)
        }}
        onOK={() => {
          setOpenModal(false)
        }}
        data={editItem}
      />
    </div>
  )
}
